module.exports = __webpack_public_path__ + "static/index/img/baikal-102.0a147216.jpg";